import styled from '@emotion/styled';
import {
    BreakPoints,
    rem,
} from '@triumph/design-system';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import { GlobalFooter } from './GlobalFooter';
import { GlobalHeader } from './GlobalHeader';
import { StyledLayoutProps } from './Layout.types';
import { useAppContext } from '@/app/components/providers/AppContextProvider';
import { DebtorAccountProvider } from '@/app/shared/contexts/DebtorAccountContext';
import { CompanyProvider } from '@/app/shared/contexts/CompanyContext';

const WrapperContainer = styled.div<StyledLayoutProps>`
    background: #f6f8fb;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
`;

const OutletContainer = styled.div<StyledLayoutProps>`
    max-width: ${({ theme }: any) => rem(theme.breakpoints.xxxl)};
    width: 100%;
    height: 100%;
    padding: ${({ displayDesktopNav }) =>
        displayDesktopNav ? `${rem(24)}` : '0'};
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const ApplicationWrapper: React.FC = () => {
    const { breakpoint } = useAppContext();

    const displayDesktopNav = useMemo(
        () => [BreakPoints.Xl, BreakPoints.Xxl].includes(breakpoint),
        [breakpoint],
    );

    return (
        <DebtorAccountProvider>
            <CompanyProvider>
            <WrapperContainer breakpoint={breakpoint}>
                <GlobalHeader />
                <OutletContainer
                    breakpoint={breakpoint}
                    displayDesktopNav={displayDesktopNav}
                >
                    <Outlet />
                </OutletContainer>
                <GlobalFooter />
            </WrapperContainer>
            </CompanyProvider>
        </DebtorAccountProvider>
    );
};

export default ApplicationWrapper;